import justifiedLayout from 'justified-layout'

let galleryController = null

export default function initGallery() {
	galleryController?.abort()
	galleryController = new AbortController()
	const { signal } = galleryController

	const galleries = Array.from(
		document.querySelectorAll('.gallery-grid__inner'),
	)

	galleries.forEach((gallery) => {
		const items = Array.from(
			gallery.querySelectorAll('.gallery-grid--item'),
		)
		const entries = items
			.map((item) => ({
				item,
				img: item.querySelector('img'),
			}))
			.filter((entry) => entry.img)
		const images = entries.map((entry) => entry.img)

		if (!entries.length) return

		// Wait for all images to load
		function loadImages(imgs) {
			return Promise.all(
				imgs.map((img) =>
					img.complete && img.naturalWidth
						? Promise.resolve()
						: new Promise((resolve) => {
								img.addEventListener('load', resolve, {
									once: true,
								})
								img.addEventListener('error', resolve, {
									once: true,
								})
							}),
				),
			)
		}

		function layoutGallery() {
			const containerWidth = gallery.clientWidth
			if (!containerWidth) return

			const validEntries = entries.filter((entry) => entry.img.naturalWidth && entry.img.naturalHeight)
			const aspectRatios = validEntries.map(
				(entry) => entry.img.naturalWidth / entry.img.naturalHeight,
			)

			if (!aspectRatios.length) return

			const layout = justifiedLayout(aspectRatios, {
				containerWidth,
				targetRowHeight: 320,
				boxSpacing: 8,
			})

			// Set container height
			gallery.style.height = layout.containerHeight + 'px'

			// Apply box positions to ITEM wrappers
			layout.boxes.forEach((box, i) => {
				const item = validEntries[i].item
				item.style.position = 'absolute'
				item.style.left = box.left + 'px'
				item.style.top = box.top + 'px'
				item.style.width = box.width + 'px'
				item.style.height = box.height + 'px'
			})
		}

		loadImages(images).then(() => {
			if (signal.aborted) return

			layoutGallery()
			window.addEventListener('resize', layoutGallery, { signal })
		})
	})
}
